import type { ReactNode } from "react";

import { Arrange } from "@aviary";
import { Container } from "@aviary/layouts";
import FullscriptLogoSvg from "@shared/assets/logo/fullscript-logo-green-leaf-pigeon-text.svg";
import WellevateByFullscriptLogo from "@shared/assets/logo/wellevate-by-fullscript.png";
// eslint-disable-next-line @fullscript/cross-reference
import { StoreLandingFooter } from "@unauthenticated/signupSignin/components";

import * as styles from "./WellevateAuthWrapper.styles";

interface Props {
  children: ReactNode;
  hasWideContent?: boolean;
}

const WellevateAuthWrapper = ({ children, hasWideContent }: Props) => {
  return (
    <Container css={styles.container}>
      <header css={styles.header}>
        <FullscriptLogoSvg css={styles.logo} />
        <img src={WellevateByFullscriptLogo} css={styles.logo} />
      </header>
      <Arrange
        justify="center"
        css={[styles.content, hasWideContent && styles.wideContent]}
        isFullwidth
      >
        {children}
      </Arrange>
      <StoreLandingFooter />
    </Container>
  );
};

export { WellevateAuthWrapper };
